const noop = () => {
  console.log('神策埋点已下线，请使用观测云埋点')
}
global.sa = {
  init: noop,
  quick: noop,
  track: noop,
  registerPage: noop,
  login: noop,
  setProfile: noop
}

export function init() {
  noop()
}

export function initAppConfig() {
  noop()
}

const TRACK = (global.TRACK = function() {
  noop()
})

TRACK.init = init
TRACK.initAppConfig = initAppConfig

export default TRACK
